<template>
    <div>
        <!-- DIALOG -->
        <ComunDialogComp v-model="estadoComp" maxWidth="1200" title="Calendario de mis evaluaciones"
            @close-modal="$emit('close')">
            <template v-slot:body>
                <v-row>
                    <v-col cols="12" md="11" class="d-flex justify-center pl-md-12">
                        <v-btn fab dark x-small class="ml-md-12 btn_block_style2" @click="prev">
                            <v-icon>fa-chevron-left</v-icon>
                        </v-btn>
                        <v-toolbar-title class="mx-2">{{ title }}</v-toolbar-title>
                        <v-btn fab dark x-small class="btn_block_style2" @click="next">
                            <v-icon>fa-chevron-right</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="1" class="d-flex justify-center">
                        <v-menu bottom right>
                            <template v-slot:activator="{ on }">
                                <v-btn class="btn_block_style2" dark v-on="on">
                                    <span>{{ typeToLabel[type] }}</span>
                                    <v-icon right>fa-chevron-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="type = 'day'">
                                    <v-list-item-title>Día</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="type = 'week'">
                                    <v-list-item-title>Semana</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="type = 'month'">
                                    <v-list-item-title>Mes</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>
                    <v-col cols="12">
                        <v-sheet height="700">
                            <v-calendar v-if="datosListos" style="border: 1px solid #e7e7e7" ref="calendar" v-model="focus" color="primary"
                                :events="combinedEvents" :event-color="getEventColor" :now="today" :type="type"
                                @click:event="showEvent" @click:more="viewDay" @click:date="viewDay" @change="updateRange"
                                :short-weekdays="false" :weekdays="diaHabil" :short-months="false" :short-intervals="false"
                                :first-interval="intervals.first" :interval-minutes="intervals.minutes"
                                :interval-count="intervals.count" :interval-height="intervals.height"></v-calendar>
                        </v-sheet>
                    </v-col>
                </v-row>
            </template>
        </ComunDialogComp>



        <!-- MODAL DEL CALENDARIO ACADÉMICO -->
        <ComunDialogComp v-model="selectedOpen" :activator="selectedElement" maxWidth="500"
            @close-modal="selectedOpen = false" title="Detalle de la evaluación">
            <template v-slot:body>
                <template v-if="selectedEvent.nombre_evaluacion">
                    <v-row>
                        <v-col class="d-flex justify-center">
                            <v-chip color="primary" class="mx-2" label>
                                NIVEL: {{ selectedEvent.desc_nivel }}
                            </v-chip>
                            <v-chip color="primary" class="mx-2" label>
                                GRADO: {{ selectedEvent.desc_grado }}
                            </v-chip>
                            <v-chip color="primary" class="mx-2" label>
                                SECCIÓN: {{ selectedEvent.nombre_seccion }}
                            </v-chip>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-card-title :style="{ background: selectedEvent.color_curso }"
                                    class="d-flex justify-center">
                                    <v-chip color="white font-weight-black">
                                        <v-icon left dark small>{{ selectedEvent.icono_curso }}</v-icon>
                                        {{ selectedEvent.desc_curso }}
                                    </v-chip>
                                </v-card-title>
                                <v-card-text>
                                    <v-col class="pt-2">
                                        <p class="black--text"><span class="font-weight-black">Profesor:</span>
                                            {{ selectedEvent.profesor }}</p>
                                        <p class="black--text"><span class="font-weight-black">Nombre:</span>
                                            {{ selectedEvent.nombre_evaluacion }}</p>
                                        <p class="black--text"><span class="font-weight-black">Objetivo:</span>
                                            {{ selectedEvent.objetivo_evaluacion }}</p>
                                        <p class="black--text"><span class="font-weight-black">Observación:</span>
                                            {{ selectedEvent.observacion_evaluacion || "No hay observaciones" }}</p>
                                        <p class="black--text"><span class="font-weight-black">Tipo:</span> {{
                                            selectedEvent.desc_tipo
                                        }}
                                        </p>
                                        <p class="black--text"><span class="font-weight-black">Fecha:</span> {{
                                            selectedEvent.fecha |
                                            filtroFecha }}</p>
                                        <p class="black--text"><span class="font-weight-black">Hora:</span> {{
                                            selectedEvent.hora_inicio
                                            | filtroFormatoHora }} - {{ selectedEvent.hora_fin | filtroFormatoHora }}</p>
                                        <p class="black--text">
                                            <span class="font-weight-black"> Estado: </span><v-chip
                                                :color="selectedEvent.color_estado" class="font-weight-black" dark>
                                                {{ selectedEvent.estado_evaluacion }}
                                            </v-chip>
                                        </p>
                                    </v-col>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>
                <template v-else>
                    <v-card color="grey lighten-4" min-width="150px" heigth="200px" flat>
                        <v-toolbar :color="selectedEvent.color" dark>
                            <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>

                        <v-card-text>
                            <v-form>
                                {{ selectedEvent.name }} - {{ selectedEvent.details }}
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn text color="secondary" @click="selectedOpen = false">
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>



            </template>
        </ComunDialogComp>

    </div>
</template>

<script>
import axios from "@/helpers/axios";
import moment from 'moment'
import ComunDialogComp from "../../../components/ComponentsEst/ComunDialogComp.vue";
import { mapState  } from 'vuex'; //mapActions

export default {
    name: 'calendarioEvaluacionDocente',
    components: {
        ComunDialogComp
    },
    props: {
        estadoComp: {
            type: Boolean
        },
        parametros: {
            type: Object
        },

    },

    data: () => ({
        datoLogin: sessionStorage, // variables de sesion del usuario
        test: false,
        today: moment().format('YYYY-MM-DD'),
        focus: '',
        type: 'month',

        typeToLabel: {
            month: 'Mes',
            week: 'Semana',
            day: 'Día',
            //'4day': '4 Days',
        },


        intervals: {
            first: 11,
            minutes: 30,
            count: 30,
            height: 40,
        },

        start: null,
        end: null,

        events: [],
        name: null,
        details: null,
        color: null,

        // ventana de detalles del item
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,

        diaHabil: [1,2,3,4,5,6],
        events2: [],

        datosListos: false,

    }),


    computed: {
        ...mapState({
            idsDiasSeleccionados: "idsDiasSeleccionados",
            fechasFeriado: "fechasFeriado",
        }),

        combinedEvents() {
            // Combinar los dos conjuntos de eventos en uno solo para renderizados

            console.log(this.events);
            console.log(this.events2);

            return [...this.events, ...this.events2];
        },

        title() {
            const { start, end } = this
            if (!start || !end) {
                return ''
            }

            const startMonth = this.monthFormatter(start)
            // const endMonth = this.monthFormatter(end)
            // const suffixMonth = startMonth === endMonth ? '' : endMonth

            const startYear = start.year
            // const endYear = end.year
            // const suffixYear = startYear === endYear ? '' : endYear

            const startDay = start.day
            // const endDay = end.day

            switch (this.type) {
                case 'month':
                    return `${startMonth} ${startYear}`
                case 'week':
                break
                /* case '4day':
                    return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}` */

                case 'day':
                    return `${startMonth} ${startDay} de ${startYear}`
            }
            return ''
        },

        monthFormatter() {
            return this.$refs.calendar.getFormatter({
                timeZone: 'UTC', month: 'long',
            })
        },
    },

    watch: {
        // cada vez que la pregunta cambie, esta función será ejecutada
        estadoComp() {

            if (this.estadoComp) {
                this.loadMain()
            }
        }
    },

    created() {
        this.loadMain();
    },

    methods: {

        // componente de  calendario
        cerrarCalendario() {
            this.type = 'month'
        },

        async loadMain() {
            try {
                const events = []

                let params = { id_alumno: this.parametros.id_alumno, id_colegio: this.parametros.id_colegio, id_ano_letivo: this.parametros.id_ano_lectivo }
                let response = await axios.post(`/evaluacion/alumnos/view/`, { filter: params })
                let dataEvaluacion = response.data

                //1.- Se dispara el action , me traigo el estado y lo igualo a this.diasHabil
                this.$store.dispatch('getDiasHabiles').then(() => {
                    this.diaHabil = this.idsDiasSeleccionados.idsDiasSeleccionados[0].dias_seleccionados;
                })

                dataEvaluacion.forEach(evalD => {
                    let eventData = evalD
                    eventData.id = evalD.id
                    eventData.name = ` ${evalD.nombre_evaluacion}
                                            SECCIÓN: ${evalD.nombre_seccion}, 
                                            GRADO: ${evalD.desc_grado}`
                    eventData.color = evalD.color_estado

                    eventData.start = `${evalD.fecha} ${evalD.hora_inicio}`
                    eventData.end = `${evalD.fecha} ${evalD.hora_fin}`

                    events.push(eventData)
                })

                //2.- Aca me traigo los dias feriados
                this.$store.dispatch("getFechasFeriado").then(() => {
                    const eventos = this.fechasFeriado.fechasFeriado.map((evento) => ({
                        name: evento.name,
                        start: evento.start,
                        end: evento.end,
                        color: evento.color,
                        details: evento.details,
                        id: evento.id,
                    }));

                    this.events2 = eventos;
                })

                this.events = events

                this.datosListos = true;
            }

            catch (error) {
                console.log(error);
            }
        },


        viewDay({ date }) {
            this.focus = date
            this.type = 'day'
        },

        getEventColor(event) {
            return event.color
        },


        prev() {
            this.$refs.calendar.prev()
        },


        next() {
            this.$refs.calendar.next()
        },

        kin() {
            alert("kin")
        },


        showEvent({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                setTimeout(() => this.selectedOpen = true, 10)
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                setTimeout(open, 10)
            }
            else {
                open()
            }

            nativeEvent.stopPropagation()
        },


        updateRange({ start, end }) {
            this.start = start
            this.end = end
        },

        rnd(a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a
        },


        formatDate(a, withTime) {
            return withTime
                ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
                : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`
        },

        showIntervalLabel(interval) {
            return interval.minute === 0
        },

    },
}
</script>
<style>
/*.pl-1 strong{
     display: none;
 }*/
</style>

